import {Link} from "./links-type";


export class LinksHandler {

  constructor(editor, $scope, isShortnerDisabled) {
    this.editor = editor;
    this.$scope = $scope; // the scope of the <codemirror-and-toolbar> directive
    this.allLinks = {}; // Contains all links, even those that have been deleted, so that we can handle undo
    this.linksByIds = {};
    this.isShortnerDisabled = isShortnerDisabled;
  }

  linkAdded(link) {
    let linkCopy = new Link();
    linkCopy.setIsShortnerDisabled(this.isShortnerDisabled);
    linkCopy.setIdAndOffsetsAndUrl(link);
    this.linksByIds[link.id] = linkCopy;
    this.allLinks[link.id] = linkCopy;
  }

  linkChanged(link) {
    this.linksByIds[link.id].setIdAndOffsetsAndUrl(link);
  }

  linkRemoved(link) {
    delete this.linksByIds[link.id];
  }

  // called outside of angular
  linkClicked(linkId) {
    this.applySelectedLink(this.linksByIds[linkId]);
  }

  // called outside of angular
  noLinkClicked() {
    this.applySelectedLink(null);
  }

  applySelectedLink(link) {
    this.$scope.$apply(() => this.$scope.selectedLink = link);
  }

  getLinks() {
    let links = Object.values(this.linksByIds).map(link => ({
      start: link.startRaw,
      end: link.endRaw,
      url: link.url,
      wrap: link.wrapped
    }));
    return links.sort((a, b) => a.start - b.start);
  }

  setWrapFromModel(modelLinks) {
    let links = Object.values(this.linksByIds);
    for (let i = 0; i < modelLinks.length; i++) {
      let link = links.find(link => link.startRaw === modelLinks[i].start &&
                                    link.endRaw === modelLinks[i].end &&
                                    link.url === modelLinks[i].url);
      if (link) {
        link.wrapped = modelLinks[i].wrap;
      }
    }
  }
}
